import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../../../../contexts/AuthContext'
import IconifyIcon from '../../../../components/wrapper/IconifyIcon'
import AuthPanel from '../../../auth/AuthPanel'

const LoginButton = () => {
  const { t } = useTranslation()
  const { user, logout, signInWithGoogle, signInWithEmail, signUpWithEmail } = useAuth()
  const [showModal, setShowModal] = useState(false)
  const [isSignUp, setIsSignUp] = useState(false)
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  if (user) {
    return (
      <div className="d-flex align-items-center gap-2">
        <button 
          className="btn d-flex align-items-center gap-2" 
          style={{
            backgroundColor: '#00FF41',
            border: '1px solid #00FF41',
            color: '#000',
            fontWeight: '500'
          }}
        >
          <IconifyIcon icon="mdi:account-check" className="fs-18" />
          <span className="d-none d-md-inline">{user.displayName || user.email.split('@')[0]}</span>
        </button>
        <button 
          className="btn d-flex align-items-center gap-1" 
          onClick={() => logout()}
          style={{
            backgroundColor: 'transparent',
            border: '1px solid #666',
            color: '#ccc',
            fontSize: '0.8rem',
            padding: '6px 10px'
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = '#dc3545'
            e.target.style.borderColor = '#dc3545'
            e.target.style.color = '#fff'
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = 'transparent'
            e.target.style.borderColor = '#666'
            e.target.style.color = '#ccc'
          }}
        >
          <IconifyIcon icon="mdi:logout" className="fs-16" />
          <span className="d-none d-md-inline">{t('oracleChat.signOut')}</span>
        </button>
      </div>
    )
  }

  const handleGoogleSignIn = async () => {
    try {
      setLoading(true)
      setError('')
      await signInWithGoogle()
      setShowModal(false)
    } catch (error) {
      setError('Failed to sign in with Google: ' + error.message)
    } finally {
      setLoading(false)
    }
  }

  const handleEmailAuth = async (e) => {
    e.preventDefault()
    try {
      setLoading(true)
      setError('')
      
      if (isSignUp) {
        await signUpWithEmail(email, password)
      } else {
        await signInWithEmail(email, password)
      }
      setShowModal(false)
    } catch (error) {
      setError(`${isSignUp ? 'Sign up' : 'Sign in'} failed: ` + error.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <button 
        className="btn d-flex align-items-center gap-2"
        style={{
          backgroundColor: '#00FF41',
          border: '1px solid #00FF41',
          color: '#000',
          fontWeight: '600',
          letterSpacing: '1px',
          textTransform: 'uppercase',
          fontSize: '0.8rem',
          padding: '8px 16px',
          transition: 'all 0.3s ease',
          boxShadow: '0 0 10px rgba(0, 255, 65, 0.3)'
        }}
        onClick={() => setShowModal(true)}
        onMouseEnter={(e) => {
          e.target.style.boxShadow = '0 0 20px rgba(0, 255, 65, 0.6)'
          e.target.style.transform = 'translateY(-1px)'
        }}
        onMouseLeave={(e) => {
          e.target.style.boxShadow = '0 0 10px rgba(0, 255, 65, 0.3)'
          e.target.style.transform = 'translateY(0)'
        }}
      >
        <IconifyIcon icon="mdi:login" className="fs-18" />
        <span className="d-none d-md-inline">{t('oracleChat.signIn')}</span>
      </button>

      {showModal && (
        <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.8)' }}>
          <div className="modal-dialog">
            <div className="modal-content filterbet-auth-modal">
              <AuthPanel
                email={email}
                password={password}
                error={error}
                isSignUp={isSignUp}
                loading={loading}
                onEmailChange={setEmail}
                onGoogleSignIn={handleGoogleSignIn}
                onPasswordChange={setPassword}
                onRequestClose={() => setShowModal(false)}
                onSubmit={handleEmailAuth}
                onToggleMode={() => setIsSignUp((current) => !current)}
              />
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default LoginButton
